import React from "react";

const SuccessMessage = () => (
  <p className="text-green-600 mt-4 text-center">
    Thank you! Your message has been sent.
  </p>
);

export default SuccessMessage;
